import { render, staticRenderFns } from "./EditBadge.vue?vue&type=template&id=2dbf857b&scoped=true&"
import script from "./EditBadge.vue?vue&type=script&lang=js&"
export * from "./EditBadge.vue?vue&type=script&lang=js&"
import style0 from "./EditBadge.vue?vue&type=style&index=0&id=2dbf857b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbf857b",
  null
  
)

export default component.exports